/**
 * This class is auto generated by using the
 * "Dots.KLASIS.TsGenerator".
 * */
export const footer = {

    link: {
        aboutPage: `Par lapu`,
        accessibility: `Piekļūstamības paziņojums`,
        api: `Lietojumprogrammatūras saskarne (API)`,
        contacts: `Kontakti`,
        lodResources: `Atvērtie saistītie dati`,
        privacyPolicy: `Privātuma politika`,
        siteMap: `Lapas karte`,
    },
    subtitle: {
        about: `Visas klasifikācijas ir paredzētas publiskajai apskatei un lietošanai. Klasifikācijas iespējams atlasīt, apskatīt, meklēt tajās informāciju, kā arī izgūt tās dažādos formātos.`,
    },
    title: {
        about: `Šī lapa darbojas kā visu statistisko klasifikāciju katalogs, kuras saturu uztur un atjauno Centrālā statistikas pārvalde.`,
    },
}
